import React, { useContext } from "react";
import "./navbar.css";
import { Link, useLocation } from "react-router-dom";
import {
  AppBar,
  Box,
  Drawer,
  Grid,
  IconButton,
  List,
  Toolbar,
} from "@mui/material";
import Toggle from "../toggle/Toggle";
import { navData } from "../Common/navdata";
import { Close, MenuOutlined } from "@mui/icons-material";
import { ThemeContext } from "../../context";

import logoimage from "../../img/logo.png";

const Navbar = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;

  const location = useLocation();

  const currentyear = () => {
    let newDate = new Date();
    let year = newDate.getFullYear();
    // console.log("clicked here", year);
    return year;
  };

  const drawerWidth = "100vw";
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    // console.log("clicked here");
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <Box
      display={{ xs: "flex", lg: "none", xl: "none" }}
      flexDirection="column"
      height="100%"
      textAlign="center"
      // backgroundColor="#000000d0"
      padding="14px 22px"
      className="drawer"
    >
      <div
        style={{
          width: "auto",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <span
          style={{
            marginTop: "12px",
            marginLeft: "6px",
          }}
        >
          <Toggle />
        </span>
        <IconButton
          onClick={handleDrawerToggle}
          sx={{
            marginLeft: "auto",
          }}
        >
          <Close size={32} className="close-icon" />
        </IconButton>
      </div>
      <List
        className="n-abc"
        onClick={handleDrawerToggle}
        sx={{
          margin: "auto",
        }}
      >
        {navData.map((item, i) => (
          <Link
            key={i}
            to={item.path}
            className={location.pathname === item.path ? "navlink-bold" : ""}
          >
            <span className="nav-l">{item.title}</span>
          </Link>
        ))}
      </List>

      <span
        style={{
          marginTop: "auto",
        }}
        className="n-w2"
      >
        {currentyear()} © All Rights Reserved. <br /> Built with{" "}
        <span
          style={{
            color: "#d4af37",
          }}
        >
          ♡{" "}
        </span>
        by DS.
      </span>

      {/* drawerend */}
    </Box>
  );

  return (
    <Grid container>
      <AppBar
        position="fixed"
        overflow="hidden"
        sx={{
          backgroundColor: darkMode
            ? "rgba(255, 255, 255, 0.2)"
            : "rgba(0, 0, 0, 0.7)",
          backdropFilter: "blur(1px)",
          // backgroundColor: "#000000d0",
          paddingLeft: { lg: "100px" },
          paddingRight: { lg: "100px" },
        }}
        elevation={0}
      >
        <Toolbar
          sx={{
            display: "flex",
            width: "auto",
            height: {
              xs: "60px",
              md: "70px",
              lg: "75px",
              xl: "95px",
            },
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box
            marginTop="auto"
            marginBottom="auto"
            marginRight="auto"
            height={{ xs: "30px", lg: "45px" }}
            width={{ xs: "25px", lg: "38px" }}
            // boxShadow="0 0 20px #d4af37"
            className="navshadow"
          >
            <a href="https://deepangshi-dev.netlify.app/">
              <img height="100%" width="100%" src={logoimage} alt="" />
            </a>
          </Box>

          <Box
            className="nav-links"
            display={{ xs: "none", lg: "flex" }}
            marginLeft="auto"
            marginRight="auto"
          >
            {navData.map((item, i) => (
              <Link key={i} to={item.path} className="nav-l">
                <span
                  style={{
                    fontSize: "20px",
                    fontWeight: "200px",
                    marginRight: "12px",
                  }}
                  className={
                    location.pathname === item.path ? "navlink-bold" : ""
                  }
                >
                  {item.title}
                </span>
              </Link>
            ))}
          </Box>

          <Box marginLeft="auto" display={{ xs: "none", lg: "flex" }}>
            <Toggle />
          </Box>
          {/* forphone & small ipad */}
          <Box
            className="n-icon"
            display={{
              xs: "block",
              md: "block",
              lg: "none",
              xl: "none",
            }}
            marginLeft="auto"
          >
            <IconButton onClick={handleDrawerToggle}>
              <MenuOutlined size={32} className="menu-outline" />
            </IconButton>
          </Box>
          {/* drawer */}
          <Box
            display={{
              xs: "block",
              md: "block",
              lg: "none",
              xl: "none",
            }}
            width={{ xs: "auto", lg: "0" }}
          >
            <Drawer
              variant="temporary"
              anchor={"right"}
              open={mobileOpen}
              onClose={handleDrawerToggle}
              ModalProps={{
                keepMounted: true, // Better open performance on mobile.
              }}
              sx={{
                "& .MuiDrawer-paper": {
                  boxSizing: "border-box",
                  width: drawerWidth,
                  overflowX: "hidden",
                },
              }}
            >
              {drawer}
            </Drawer>
          </Box>
        </Toolbar>
      </AppBar>
    </Grid>
  );
};

export default Navbar;
